/**
 * Binom Standard tab body — renders the 2-pane paths workspace. Reads draft
 * state from the shared BinomDrawerContext so peer tabs (Campaign / Advanced)
 * can share the same draft.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';
import { AlertCircle } from 'lucide-react';

import { LoadingSpinner } from '@/components/ui/feedback/LoadingSpinner';

import BinomPathsWorkspace from './workspace/BinomPathsWorkspace';
import { useBinomDrawer } from './BinomDrawerContext';

export interface BinomStandardConfigTabImplProps {
  killSwitch: boolean;
}

const BinomStandardConfigTabImpl: FC<BinomStandardConfigTabImplProps> = ({
  killSwitch,
}) => {
  const drawer = useBinomDrawer();

  if (drawer.isLoading) {
    return (
      <div className="flex min-h-0 flex-1 items-center justify-center py-12">
        <LoadingSpinner />
      </div>
    );
  }
  if (drawer.isError || !drawer.draft) {
    return (
      <div className="flex min-h-0 flex-1 items-center">
        <div className="flex w-full items-center gap-2 rounded-md border border-destructive/40 bg-destructive/5 p-3 text-sm text-destructive">
          <AlertCircle className="h-4 w-4 shrink-0" aria-hidden />
          <span>
            Failed to load Binom rotation. {drawer.errorMessage ?? ''}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-0 flex-1 flex-col gap-2 overflow-hidden pr-1">
      {killSwitch && (
        <p className="rounded-md border border-warning/40 bg-warning/10 px-3 py-2 text-xs text-warning">
          Pushes are paused. Save is disabled until you resume.
        </p>
      )}
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
        <BinomPathsWorkspace
          draft={drawer.draft}
          patchDefaultPath={drawer.patchDefaultPath}
          patchGroupPath={drawer.patchGroupPath}
          addDefaultPath={drawer.addDefaultPath}
          removeDefaultPath={drawer.removeDefaultPath}
          moveDefaultPath={drawer.moveDefaultPath}
          addGroupPath={drawer.addGroupPath}
          removeGroupPath={drawer.removeGroupPath}
          moveGroupPath={drawer.moveGroupPath}
          addLanderTo={drawer.addLanderTo}
          removeLanderFrom={drawer.removeLanderFrom}
          moveLanderIn={drawer.moveLanderIn}
          addOfferTo={drawer.addOfferTo}
          removeOfferFrom={drawer.removeOfferFrom}
          moveOfferIn={drawer.moveOfferIn}
        />
      </div>
    </div>
  );
};

export default BinomStandardConfigTabImpl;
